module.exports = __webpack_public_path__ + "img/bg_classify1.778b41a5.png";